'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localize = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _locale = require('./locale');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(slice) {
  return function (state) {
    var scopedState = slice ? state[slice] : state;
    return {
      currentLanguage: (0, _locale.getActiveLanguage)(scopedState).code,
      translate: (0, _locale.getTranslate)(scopedState)
    };
  };
};
var localize = exports.localize = function localize(Component) {
  var slice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (0, _reactRedux.connect)(mapStateToProps(slice))(Component);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-localize-redux/lib/Localize.js
// module id = 1430
// module chunks = 0